module.exports = __webpack_public_path__ + "static/img/a115.9c6747f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a115.jpg
// module id = bN0A
// module chunks = 0